import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, TextField } from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import api, { VendorDto, VendorUpdateDto } from "../../../api";
import { createStateReducer, notif } from "../../utils";

export interface VendorDialogProps {
  vendor: Partial<VendorUpdateDto> | null;
  onSubmit?: (dto: VendorDto | null, action: "added" | "updated" | "closed") => void;
}

export const VendorDialog = (props: VendorDialogProps) => {
  const { vendor, onSubmit } = props;
  const [open, setOpen] = useState(false);
  const reducer = createStateReducer<VendorUpdateDto>()
  const [state, dispatch] = useReducer(reducer, null);

  const handleAccept = async () => {
    try {
      if (state?.id) { 
        const vendor = await api.vendor.update(state as any);
        if (onSubmit) onSubmit(vendor, "updated");
      } else {
        const vendor = await api.vendor.add(state as any);
        if (onSubmit) onSubmit(vendor, "added");
      }
      setOpen(false);
    } catch (err) {
      notif(err, "error");
    }
  };
  const handleClose = () => {
    if (onSubmit) onSubmit(null, "closed");
    setOpen(false);
  };

  useEffect(() => {
    if (vendor !== null) {
      dispatch({ state: vendor, replace: true });
      setOpen(true);
    }
  }, [vendor]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>{state?.id ? "EDIT VENDOR" : "ADD VENDOR"}</DialogTitle>
      <DialogContent dividers>
        <FormGroup sx={{ minWidth: 300 }}>
          <TextField id="name" label="Name" required variant="standard" value={state?.name ?? ""} onChange={(e) => dispatch({ state: { name: e.target.value } })} />
          <TextField id="supplierId" label="Supplier ID" variant="standard" value={state?.supplierId ?? ""} onChange={(e) => dispatch({ state: { supplierId: e.target.value } })} />
          <FormControlLabel label="Enabled" control={<Checkbox checked={state?.isEnabled ?? false} onChange={(e,c) => dispatch({ state: { isEnabled: c } })} />} />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAccept}>Accept</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
